// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__AamTd","content":"RecentSearches_content__QCINe"};